import { environment } from './environments/environment';

export const awsmobile = environment.cognito;